import React from 'react';
import Logo from './assets/logo.svg';
import ErrorImg from './assets/error.svg';
import PT from 'prop-types';

import Button from '../Button/Button';
import moment from 'moment';

const ErrorPage = ({ nameOfError, errorTitle, recommendation, errorButton, errorClick }) => {
  return (
    <div className="app">
      <div className="error-page">
        <strong className="error-page__logo">
          <img className="error-page__logo-img" src={Logo} alt="anvileight" />
        </strong>
        <div className="error-page__img">
          <img className="error-page__img-item" src={ErrorImg} alt="error page" />
        </div>
        <div className="error-page__content">
          <p className="error-page__content-name">{nameOfError}</p>
          <h2 className="error-page__content-process">{errorTitle}</h2>
          <p className="error-page__content-recommendation">{recommendation}</p>
        </div>
        <Button text={errorButton} variant="primary" onClick={errorClick} />
        <span className="error-page__copyright">© Copyright {moment().format('YYYY')} AnvilEight LTD</span>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  nameOfError: PT.string.isRequired,
  errorTitle: PT.string.isRequired,
  recommendation: PT.string.isRequired,
  errorButton: PT.string.isRequired,
  errorClick: PT.func.isRequired,
};

export default ErrorPage;
